
export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0A1628] mb-8">Política de Cookies</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última actualización: 6 de febrero de 2026</p>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">1. ¿Qué son las Cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. 
              Permiten al sitio web recordar sus acciones y preferencias durante un período de tiempo, por lo que no 
              tiene que volver a configurarlas cada vez que regrese al sitio o navegue de una página a otra.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">2. ¿Qué Cookies Utiliza PreBedAI?</h2>
            
            <div className="mt-6">
              <h3 className="text-xl font-bold text-[#0A1628] mb-3">2.1 Cookies Técnicas (Necesarias)</h3>
              <p>Estas cookies son esenciales para el funcionamiento del sitio web y no pueden ser desactivadas:</p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-2">Cookie</th>
                      <th className="text-left py-2">Finalidad</th>
                      <th className="text-left py-2">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-100">
                      <td className="py-2">session_id</td>
                      <td className="py-2">Mantener la sesión del usuario</td>
                      <td className="py-2">Sesión</td>
                    </tr>
                    <tr className="border-b border-gray-100">
                      <td className="py-2">cookie_consent</td>
                      <td className="py-2">Recordar preferencias de cookies</td>
                      <td className="py-2">1 año</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-6">
              <h3 className="text-xl font-bold text-[#0A1628] mb-3">2.2 Cookies Analíticas</h3>
              <p>Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web:</p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-2">Cookie</th>
                      <th className="text-left py-2">Proveedor</th>
                      <th className="text-left py-2">Finalidad</th>
                      <th className="text-left py-2">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-100">
                      <td className="py-2">_ga</td>
                      <td className="py-2">Google Analytics</td>
                      <td className="py-2">Distinguir usuarios</td>
                      <td className="py-2">2 años</td>
                    </tr>
                    <tr className="border-b border-gray-100">
                      <td className="py-2">_gid</td>
                      <td className="py-2">Google Analytics</td>
                      <td className="py-2">Distinguir usuarios</td>
                      <td className="py-2">24 horas</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-6">
              <h3 className="text-xl font-bold text-[#0A1628] mb-3">2.3 Cookies de Funcionalidad</h3>
              <p>Permiten recordar sus preferencias y mejorar su experiencia:</p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-2">Cookie</th>
                      <th className="text-left py-2">Finalidad</th>
                      <th className="text-left py-2">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-100">
                      <td className="py-2">language_preference</td>
                      <td className="py-2">Recordar idioma seleccionado</td>
                      <td className="py-2">1 año</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">3. Base Legal</h2>
            <p>
              El tratamiento de datos mediante cookies se basa en el consentimiento del usuario, 
              excepto para las cookies técnicas que son necesarias para el funcionamiento del sitio web, 
              conforme a la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información 
              y de Comercio Electrónico (LSSI-CE).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">4. Cómo Gestionar las Cookies</h2>
            <p>Puede gestionar y/o eliminar las cookies según sus preferencias:</p>
            
            <div className="mt-6 space-y-4">
              <div>
                <h3 className="font-bold text-[#0A1628] mb-2">En su Navegador:</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios</li>
                  <li><strong>Firefox:</strong> Opciones → Privacidad y seguridad → Cookies y datos del sitio</li>
                  <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies y datos de sitios web</li>
                  <li><strong>Edge:</strong> Configuración → Cookies y permisos del sitio → Cookies</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-[#0A1628] mb-2">A través de Nuestro Panel de Cookies:</h3>
                <p>
                  Puede modificar sus preferencias de cookies en cualquier momento a través del panel de 
                  configuración de cookies disponible en el pie de página de nuestro sitio web.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">5. Cookies de Terceros</h2>
            <p>
              Algunos de nuestros socios pueden establecer cookies en su dispositivo cuando visita nuestro sitio web:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>Google Analytics:</strong> Para análisis de tráfico y comportamiento (<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#6D28D9] hover:underline">Política de Privacidad</a>)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">6. Consecuencias de Deshabilitar Cookies</h2>
            <p>
              La desactivación de cookies puede afectar a la funcionalidad del sitio web. Algunas características 
              pueden no funcionar correctamente si las cookies están deshabilitadas.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>No podremos recordar sus preferencias</li>
              <li>Algunas funcionalidades pueden no estar disponibles</li>
              <li>El sitio puede funcionar más lentamente</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">7. Actualizaciones de esta Política</h2>
            <p>
              PreBedAI puede actualizar esta Política de Cookies para reflejar cambios en nuestras prácticas 
              de cookies o por otros motivos operativos, legales o regulatorios.
            </p>
          </section>

          <section className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-bold text-[#0A1628] mb-4">Más Información</h3>
            <p>
              Para más información sobre cómo tratamos sus datos personales, consulte nuestra 
              <a href="/politica-privacidad" className="text-[#6D28D9] hover:underline ml-1">Política de Privacidad</a>.
            </p>
            <p className="mt-4">
              Si tiene preguntas sobre nuestra Política de Cookies, contáctenos en: 
              <a href="mailto:info@prebedai.com" className="text-[#6D28D9] hover:underline ml-1">info@prebedai.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
